module.exports = __webpack_public_path__ + "static/media/MDX.8e72f6f2.png";